// The planner toolbar's glyphs, drawn as in the approved design
// (Resource Planning mock-up). Stroke only, currentColor, so the library's
// buttons colour them.

type IconProps = { size?: number };

const svg = (size: number, viewBox: string, children: JSX.Element) => (
  <svg className="oly-reset" width={size} height={size} viewBox={viewBox} aria-hidden="true">
    {children}
  </svg>
);

export const PeopleGlyph = ({ size = 16 }: IconProps) =>
  svg(size, '0 0 16 16', (
    <>
      <circle cx="6" cy="5" r="2.3" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path d="M1.8 13.5 C1.8 10.6 3.6 9.2 6 9.2 C8.4 9.2 10.2 10.6 10.2 13.5" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="11.5" cy="5.6" r="1.8" fill="none" stroke="currentColor" strokeWidth="1.3" />
      <path d="M11.2 9.4 C13.2 9.4 14.4 10.8 14.4 13.5" fill="none" stroke="currentColor" strokeWidth="1.3" />
    </>
  ));

export const ProjectsGlyph = ({ size = 16 }: IconProps) =>
  svg(size, '0 0 16 16', (
    <>
      <rect x="1.8" y="4.5" width="12.4" height="9" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <path d="M5.8 4.5 V3 C5.8 2.5 6.2 2.2 6.6 2.2 H9.4 C9.8 2.2 10.2 2.5 10.2 3 V4.5 M1.8 8.5 H14.2" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </>
  ));

export const TimelineGlyph = ({ size = 16 }: IconProps) =>
  svg(size, '0 0 16 16', <path d="M2 3.5 H9 M5 8 H14 M3.5 12.5 H11" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />);

export const CollapseAllGlyph = ({ size = 14 }: IconProps) =>
  svg(size, '0 0 14 14', <path d="M4 2.5 L7 5.5 L10 2.5 M4 11.5 L7 8.5 L10 11.5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />);

export const ExpandAllGlyph = ({ size = 14 }: IconProps) =>
  svg(size, '0 0 14 14', <path d="M4 5.5 L7 2.5 L10 5.5 M4 8.5 L7 11.5 L10 8.5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />);

export const PrintGlyph = ({ size = 15 }: IconProps) =>
  svg(size, '0 0 16 16', (
    <>
      <path d="M4.5 6 V2 H11.5 V6 M4.5 11.5 H2.5 V6 H13.5 V11.5 H11.5" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <rect x="4.5" y="9" width="7" height="5" fill="none" stroke="currentColor" strokeWidth="1.3" />
    </>
  ));

export const CalendarGlyph = ({ size = 15 }: IconProps) =>
  svg(size, '0 0 16 16', (
    <>
      <rect x="2" y="3" width="12" height="11" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.3" />
      <path d="M2 6.5 H14 M5.5 1.5 V4.5 M10.5 1.5 V4.5" stroke="currentColor" strokeWidth="1.3" />
    </>
  ));

export const SettingsGlyph = ({ size = 15 }: IconProps) =>
  svg(size, '0 0 16 16', (
    <>
      <path d="M2 4 H14 M2 8 H14 M2 12 H14" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="5" cy="4" r="1.7" fill="var(--surface)" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="11" cy="8" r="1.7" fill="var(--surface)" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="7" cy="12" r="1.7" fill="var(--surface)" stroke="currentColor" strokeWidth="1.3" />
    </>
  ));

export const PlusGlyph = ({ size = 12 }: IconProps) =>
  svg(size, '0 0 10 10', <path d="M5 1 V9 M1 5 H9" stroke="currentColor" strokeWidth="1.5" />);

export const CloseGlyph = ({ size = 12 }: IconProps) =>
  svg(size, '0 0 12 12', <path d="M2 2 L10 10 M10 2 L2 10" stroke="currentColor" strokeWidth="1.5" />);
